(() => {
  'use strict';
  const selector = '[data-language-switcher]';
  const close = (disclosure, restoreFocus = false) => {
    disclosure.open = false;
    if (restoreFocus) disclosure.querySelector('summary').focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(disclosure => {
      if (!disclosure.contains(event.target)) close(disclosure);
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(`${selector}[open]`).forEach(disclosure => {
      if (!disclosure.contains(event.target)) close(disclosure);
    });
  });
  document.addEventListener('keydown', event => {
    const disclosure = event.target.closest(`${selector}[open]`);
    if (disclosure && event.key === 'Escape') {
      event.preventDefault();
      close(disclosure, true);
    }
  });
  // Shopify handles localization and return URLs in production. Only the local
  // Liquid preview uses German at / and English at /en.
  document.addEventListener('submit', event => {
    if (!event.target.matches('.language-form') || document.body.dataset.preview !== 'true') return;
    const language = event.submitter?.value;
    if (!language) return;
    event.preventDefault();
    const path = location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    location.href = (language === 'en' ? '/en' + (path === '/' ? '' : path) : path) + location.search + location.hash;
  });
})();
